// BYBORN: colour swatches on product cards, as on the old theme.
// Clicking a swatch shows that colour's image on the card and links the card to that colour.
if (!customElements.get('card-swatches')) {
  customElements.define(
    'card-swatches',
    class CardSwatches extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onSwatchClick.bind(this));
      }

      onSwatchClick(event) {
        const swatch = event.target.closest('.card-swatch');
        if (!swatch || swatch.getAttribute('aria-pressed') === 'true') return;

        this.querySelectorAll('.card-swatch').forEach((button) => {
          button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
        });

        const card = this.closest('.card-wrapper');
        if (!card) return;
        this.updateImage(card, swatch.dataset);
        this.updateLinks(card, swatch.dataset.variantId);
      }

      // Only the card image changes; the second image shown on hover stays the product's second image.
      updateImage(card, { mediaSrc, mediaSrcset, mediaAlt, mediaWidth, mediaHeight }) {
        const image = card.querySelector('.card__media .media > img');
        if (!image || !mediaSrc) return;

        image.srcset = mediaSrcset;
        image.src = mediaSrc;
        image.alt = mediaAlt;
        image.width = mediaWidth;
        image.height = mediaHeight;
      }

      updateLinks(card, variantId) {
        if (!variantId) return;

        const productPath = new URL(this.dataset.productUrl, window.location.origin).pathname;
        card.querySelectorAll('a[href]').forEach((link) => {
          const url = new URL(link.href, window.location.origin);
          if (url.pathname !== productPath) return;

          url.searchParams.set('variant', variantId);
          link.href = url.toString();
        });
      }
    }
  );
}
